<template>
  <div class="icon-grid-container">
    <div class="icon-grid-list"
         v-for="(list, index) in iconGrid"
         :key="index"
    >
      <router-link class="icon-grid-item"
                   :class="{ 'icon-grid-item-express': itemKey === 0 && expressList.length !== 0 }"
                   v-for="(item, itemKey) in list"
                   :key="itemKey"
                   :to="{ name: item.name }"
      >
        <ym-img class="icon-grid-item-icon"
                :src="require(`@/assets/img/user_center/icon_${item.icon}.png`)"
        />
        <span class="text">{{ item.title }}</span>
      </router-link>
      <swiper v-if="expressList.length !== 0"
              class="express-container"
              :options="expressList.length === 1 ? swiperSingleOption : swiperOption"
              ref="swiper"
      >
        <swiper-slide class="express-swiper-item"
                      v-for="(item, index) in expressList"
                      :key="index"
        >
          <img class="express-swiper-item-arrow"
               :src="require('@/assets/img/user_center/icon_express_arrow.png')"
               alt=""
          />
          <router-link class="express-swiper-item-container"
                       :to="{ name: 'ExpressDetail', params: { sn: item.postId } }"
          >
            <div class="top">
              <div class="status">{{ item.status }}</div>
              <div class="title ym-line-ellipsis">{{ item.title }}</div>
            </div>
            <div class="bottom ym-line-ellipsis">{{ item.stateContent }}</div>
          </router-link>
        </swiper-slide>
        <template #pagination>
          <div class="swiper-pagination"></div>
        </template>
      </swiper>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default {
    name: 'IconGrid',
    components: {
      swiper,
      swiperSlide,
    },
    props: {
      iconGrid: {
        type: Array,
      },
      expressList: {
        type: Array,
      },
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          spaceBetween: 15,
          loop: true,
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        swiperSingleOption: {
          loop: false,
        },
      };
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .icon-grid-container {
    width: 690px;
    margin: -170px auto 0;
    background-color: @color-white;
    border-radius: @border-radius-extra-large;
    overflow: hidden;
    z-index: @z-index-largest;
  }

  .icon-grid-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    background-color: @color-white;
    padding-bottom: @size-extra-medium;
  }

  .icon-grid-item {
    margin-top: @size-extra-medium;
    flex: 0 0 33.33%;
    text-align: center;
    line-height: 1;
    color: @color-text-light;
    font-size: 26px;
  }

  .icon-grid-item-icon {
    display: block;
    width: 80px;
    height: 80px;
    margin: 0 auto @size-small;
  }

  .icon-grid-item-express {
    margin-bottom: 150px;
  }

  .express-container {
    position: absolute;
    top: 190px;
    left: 30px;
    width: 630px;
    height: 140px;
    .swiper-pagination {
      bottom: -5px;
    }
  }

  .express-swiper-item {
    &-arrow {
      display: block;
      width: 38px;
      height: 15px;
      margin-left: 62px;
    }
    &-container {
      width: 630px;
      height: 125px;
      border-radius: @border-radius-medium;
      background: #f5f6f7;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: @size-small @size-base;
      box-sizing: border-box;
      .top {
        display: flex;
        align-items: center;
        .status {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          height: 30px;
          padding: 0 6px;
          border-radius: @border-radius-normal;
          background: #fea500;
          color: @color-white;
          font-size: @font-size-extra-small;
          margin-right: 10px;
        }
        .title {
          color: @color-black-dark;
          font-size: 26px;
          font-weight: @font-weight-bold;
        }
      }
      .bottom {
        color: @color-text-lighter;
        font-size: @font-size-small;
      }
    }
  }
</style>
